import { render, staticRenderFns } from "./printingStockLnventoryPlan.vue?vue&type=template&id=5840db5f"
import script from "./printingStockLnventoryPlan.vue?vue&type=script&lang=js"
export * from "./printingStockLnventoryPlan.vue?vue&type=script&lang=js"
import style0 from "./printingStockLnventoryPlan.vue?vue&type=style&index=0&id=5840db5f&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports